import { isProductPage } from 'models/ProductPageModel';
import { PageState } from 'models/PageState';

export const savingsTitle = ({ currentPage }: PageState) =>
  isProductPage(currentPage) && currentPage.product.savingsTitle;

export const savingsExplanation = ({ currentPage }: PageState) =>
  isProductPage(currentPage) && currentPage.product.savingsExplanation;

export const savingsAmount = ({ currentPage }: PageState) =>
  isProductPage(currentPage) && currentPage.product.savingsAmount;
